export enum WebSource {
  confused = 'confused',
  gocompare = 'gocompare',
  comparethemarket = 'comparethemarket',
  moneysupermarket = 'moneysupermarket',
}
